export default __webpack_public_path__ + "439c0eea1918ef143002cf62a9393e2a.png";